(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["csuite-brand-message"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = root => {
    const sections = root.matches?.('[data-cs-moment]') ? [root] : root.querySelectorAll('[data-cs-moment]');
    sections.forEach(section => {
      if (section.dataset.initialised) return;
      section.dataset.initialised = 'true';
      const button = section.querySelector('[data-cs-moment-toggle]');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let visible = false;
      const sync = () => {
        section.classList.toggle('is-visible', visible && !document.hidden && !reduced.matches);
        button.disabled = reduced.matches;
      };
      const observer = new IntersectionObserver(entries => {
        visible = entries[0].intersectionRatio >= 0.45;
        sync();
      }, {threshold:[0,0.45]});
      const toggle = () => {
        const paused = section.classList.toggle('is-paused');
        button.setAttribute('aria-pressed', String(paused));
      };
      const unload = event => {
        if (!event.target.contains(section)) return;
        observer.disconnect();
        reduced.removeEventListener('change', sync);
        document.removeEventListener('visibilitychange', sync);
        document.removeEventListener('shopify:section:unload', unload);
        button.removeEventListener('click', toggle);
      };
      button.addEventListener('click', toggle);
      reduced.addEventListener('change', sync);
      document.addEventListener('visibilitychange', sync);
      document.addEventListener('shopify:section:unload', unload);
      observer.observe(section.querySelector('.cs-moment__heading'));
      sync();
    });
  };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["csuite-product-sticky"] && !Shopify.designMode) return;
  try {
    
(() => {
 const init=()=>{
 const bar=document.querySelector('[data-cs-purchase-bar]'),info=document.querySelector('product-info');if(!bar||!info||bar.dataset.ready)return;bar.dataset.ready='true';
 const action=bar.querySelector('button'),selection=bar.querySelector('small');
 const sync=()=>{const button=info.querySelector('.product-form__submit'),picker=info.querySelector('[data-selected-variant]');let variant;try{variant=JSON.parse(picker?.textContent||'null');}catch{}
 if(!button)return;bar.hidden=button.getBoundingClientRect().bottom>85;action.textContent=button.textContent.trim();action.disabled=button.disabled||button.getAttribute('aria-disabled')==='true';selection.textContent=variant?.title||'';};
 const observer=new MutationObserver(sync);observer.observe(info,{subtree:true,attributes:true,childList:true,characterData:true});let frame;const onScroll=()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(sync);};window.addEventListener('scroll',onScroll,{passive:true});
 action.addEventListener('click',()=>{const button=info.querySelector('.product-form__submit');if(button&&!button.disabled)button.click();});
 document.addEventListener('shopify:section:unload',event=>{if(!event.target.contains(bar))return;observer.disconnect();window.removeEventListener('scroll',onScroll);cancelAnimationFrame(frame);},{once:true});sync();
 };init();document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["csuite-returns"] && !Shopify.designMode) return;
  try {
    
(function(){
  var form=document.getElementById('CSuiteReturnsForm');if(!form)return;
  var success=document.getElementById('ReturnsSuccess'),error=document.getElementById('ReturnsError');
  if(success){success.focus();return;}if(error)error.focus();
  var location=form.querySelector('#ReturnsLocation'),reason=form.querySelector('#ReturnsReason'),choices=form.querySelector('#ReturnsChoices'),special=form.querySelector('#ReturnsSpecial'),button=form.querySelector('#ReturnsSubmit');
  var outcome=form.querySelector('#ReturnsOutcome');
  function update(){
    var fault=reason.value==='Faulty or damaged'||reason.value==='Incorrect item';
    var exchange=reason.value==='Size exchange';
    var international=location.value==='Outside Australia';
    var ordinary=!fault&&!exchange&&!international;
    choices.hidden=!ordinary;
    outcome.required=ordinary;outcome.disabled=!ordinary;if(!ordinary)outcome.value='';
    special.hidden=!(fault||exchange||international);
    if(fault)special.textContent='We will assess the problem and confirm the remedy and return arrangements by email. Change of mind fees, eligibility conditions and the 14-day window do not limit your rights under Australian Consumer Law.';
    else if(exchange)special.textContent=international?'We will check stock and confirm the size exchange by email. International return postage is customer-paid. The A$20 credit bonus does not apply to exchanges.':'One complimentary size exchange per Australian order, subject to stock. Once approved, we provide a prepaid return label and cover Standard delivery of your replacement size. The A$20 credit bonus does not apply to exchanges.';
    else if(international)special.textContent='We will confirm your return instructions by email. International change of mind return postage is customer-paid. The Australian A$15 label offer and A$20 bonus do not apply.';
  }
  location.addEventListener('change',update);reason.addEventListener('change',update);update();
  // Shopify owns CAPTCHA and submission. Keep the button available if a challenge is cancelled or expires.
  window.addEventListener('pageshow',function(){if(button){button.disabled=false;button.textContent='Send return request';}});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["csuite-signature-story"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{const link=event.target.closest('[data-cs-return-product]');if(!link)return;const target=document.querySelector('product-info');if(target){event.preventDefault();target.scrollIntoView({behavior:'instant',block:'start'});const input=target.querySelector('variant-selects input');input?.focus({preventScroll:true});}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
